<template>
    <div class="accountDeliveryAddresses__container mx-auto">
        <div class="bg-white text-left border border-black pt-4">
            <div class="p-4">
                <div class="input">
                    <input
                        class="input__field text-center"
                        :placeholder="recipientPlaceholder"
                        type="text"
                        v-model="messageRecipientText"
                        :maxlength="maxRecipientCharacters">
                </div>
                <div class="input">
                    <input
                        class="input__field text-center"
                        :placeholder="messageBodyPlaceholder"
                        type="text"
                        v-model="messageBodyText"
                        :maxlength="maxCharacters">
                </div>
                <div class="input">
                    <input
                        class="input__field text-center"
                        :placeholder="senderPlaceholder"
                        type="text"
                        v-model="messageSenderText"
                        :maxlength="maxSenderCharacters">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GiftCardMessage',
    data() {
        return {
            preRecipientText: this.$t('GIFT_CARD_MESSAGE_DEAR'),
            preSenderText: this.$t('GIFT_CARD_MESSAGE_LOVE'),
            messageRecipientText: '',
            messageBodyText: '',
            messageSenderText: '',
            maxRecipientCharacters: 30,
            maxCharacters: 250,
            maxSenderCharacters: 30,
        };
    },
    mounted() {
        this.messageRecipientText = this.messageTo || '';
        this.messageBodyText = this.messageBody || '';
        this.messageSenderText = this.messageFrom || '';
    },
    beforeDestroy() {
        this.messageTo = this.messageRecipientText.trim() || this.recipientPlaceholder.slice(0, -1);
        this.messageBody = this.messageBodyText.trim() || this.messageBodyPlaceholder;
        this.messageFrom = this.messageSenderText.trim() || this.senderPlaceholder;
    },
    computed: {
        messageBody: {
            get() {
                return this.$store.getters['gifting/getMessageBody'];
            },
            set(value) {
                this.$store.commit('gifting/updateMessageBody', value);
            },
        },
        messageTo: {
            get() {
                return this.$store.getters['gifting/getMessageTo'];
            },
            set(value) {
                this.$store.commit('gifting/updateMessageTo', value);
            },
        },
        messageFrom: {
            get() {
                return this.$store.getters['gifting/getMessageFrom'];
            },
            set(value) {
                this.$store.commit('gifting/updateMessageFrom', value);
            },
        },
        address() {
            return this.$store.getters['address/getSelectedGiftingAddress'];
        },
        firstName() {
            return this.$store.getters['account/getFirstName'];
        },
        recipientPlaceholder() {
            return `${this.preRecipientText} ${this.address.first_name},`;
        },
        messageBodyPlaceholder() {
            return this.$t('GIFT_CARD_MESSAGE_THE_FLOWERS');
        },
        senderPlaceholder() {
            return `${this.preSenderText} ${this.firstName}`;
        },
    },
};
</script>
